import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useStudentTheme } from '@context/StudentThemeContext';
import { Mascots } from '@assets';
import { cx } from '../cx';

/** First-paint loader for JOURNEY mode while the dashboard query resolves. */
export const JourneyBoot: React.FC<{ label?: string }> = ({ label = 'Warming up your journey…' }) => {
  const { theme } = useStudentTheme();
  const dark = theme === 'dark';
  const reduce = useReducedMotion();

  return (
    <div
      className={cx('sp-journey', dark && 'sp-theme-dark')}
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--sp-bg)',
        padding: 24,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
        <motion.img
          src={Mascots.poseCoding.lg}
          srcSet={`${Mascots.poseCoding.sm} 512w, ${Mascots.poseCoding.lg} 960w`}
          sizes="180px"
          alt=""
          width={180}
          height={120}
          style={{ width: 180, height: 'auto', objectFit: 'contain' }}
          animate={reduce ? undefined : { y: [0, -8, 0] }}
          transition={reduce ? undefined : { duration: 2.4, repeat: Infinity, ease: 'easeInOut' }}
        />
        <div className="sp-body" style={{ color: 'var(--sp-text-muted)' }}>{label}</div>
        <div className="sp-progress" style={{ width: 180 }}>
          <motion.div
            className="sp-progress__bar"
            animate={reduce ? { width: '60%' } : { width: ['12%', '86%', '38%', '92%'] }}
            transition={reduce ? undefined : { duration: 2, repeat: Infinity, ease: 'easeInOut' }}
          />
        </div>
      </div>
    </div>
  );
};
